<script>
import axios from 'axios'
import u from '@/utils'
import ExecutionProcess from '@/components/execution/ExecutionProcess.vue'
import ExecutionDocuments from '@/components/execution/ExecutionDocuments.vue'
import ExecutionTasks from '@/components/execution/ExecutionTasks.vue'
import ExecutionEmail from '@/components/execution/ExecutionEmail.vue'
import AutomationRequestActivities from '@/components/self-service/AutomationRequestActivities.vue'
import AutomationRequestBots from '@/components/self-service/AutomationRequestBots.vue'
import AutomationRequestBotDetail from '@/components/self-service/AutomationRequestBotDetail.vue'
import moment from 'moment/moment'

export default {
  name: 'AutomationRequestView',
  components: {
    AutomationRequestBots,
    ExecutionProcess,
    ExecutionDocuments,
    ExecutionTasks,
    ExecutionEmail,
    AutomationRequestActivities,
    AutomationRequestBotDetail
  },
  props: {
    automationRequest: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showProcessView: false,
      automationRequestTabs: null,
      execution: null,
      selectedActivity: null,
      selectedBotExecution: null
    }
  },
  mounted() {
    this.getParentExecution()
  },
  methods: {
    getParentExecution() {
      axios
        .get(
          `/api/v1/automationRequests/${this.automationRequest.hexId}/parent-execution-id/`
        )
        .then(response => {
          let executionId = response.data
          if (executionId) {
            axios
              .get(
                `/api/v1/executions/${executionId}?projection=withReferenceHexId`
              )
              .then(response => {
                this.execution = response.data
              })
              .catch(e => {
                console.log(e)
              })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    handleActivitySelection(activity) {
      this.automationRequestTabs = 0
      this.selectedActivity = activity
    },

    handleClearAllSelections() {
      this.selectedActivity = null
      this.selectedBotExecution = null
    },

    handleBotExecutionSelection(executionId) {
      this.automationRequestTabs = 1
      this.selectedBotExecution = executionId
    }
  }
}
</script>

<template>
  <v-card
    :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
    v-if="execution"
  >
    <v-card-title>
      <span class="body-1 beez-bold pl-3">Request Details</span>
      <v-spacer />
    </v-card-title>
    <v-card-text>
      <div v-if="execution" class="mt-3">
        <div v-if="execution.executionType === 'WORKFLOW'">
          <v-card flat>
            <v-toolbar dense flat @click="showProcessView = !showProcessView">
              <v-toolbar-title
                class="body-2 beez-bold "
                v-text="'Process View'"
              />
              <v-spacer />
              <v-btn class="mb-2" icon small>
                <v-icon
                  >{{
                    showProcessView
                      ? 'keyboard_arrow_up'
                      : 'keyboard_arrow_down'
                  }}
                </v-icon>
              </v-btn>
            </v-toolbar>
            <div v-if="showProcessView">
              <execution-process
                :execution="execution"
                @activitySelected="handleActivitySelection"
              >
              </execution-process>
            </div>
          </v-card>
          <v-tabs v-model="automationRequestTabs" slider-color="secondary">
            <v-tabs-slider color="secondary" />
            <v-tab :key="execution.hexId + 'activity-list'">
              <span class="text-capitalize">Activity view</span>
            </v-tab>
            <v-tab :key="execution.hexId + 'bot-list'">
              <span class="text-capitalize">Bot view</span>
            </v-tab>
            <v-tab :key="execution.hexId + 'execution-mail-view'">
              <span class="text-capitalize">Emails sent</span>
            </v-tab>
            <v-tab :key="execution.hexId + 'execution-tasks-view'">
              <span class="text-capitalize">User Tasks created</span>
            </v-tab>
            <v-tab :key="execution.hexId + 'execution-docs-view'">
              <span class="text-capitalize">Documents created</span>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="automationRequestTabs">
            <v-tab-item :key="execution.hexId + 'activity-list'">
              <div v-if="automationRequestTabs === 0">
                <automation-request-activities
                  :execution="execution"
                  :selected-activity-id="selectedActivity"
                  @clearAllSelections="handleClearAllSelections"
                  @goToBotExecution="handleBotExecutionSelection"
                />
              </div>
            </v-tab-item>
            <v-tab-item :key="execution.hexId + 'execution-bot-view'">
              <div v-if="automationRequestTabs === 1">
                <automation-request-bots
                  :execution="execution"
                  :selected-execution-id="selectedBotExecution"
                  @clearAllSelections="handleClearAllSelections"
                />
              </div>
            </v-tab-item>
            <v-tab-item :key="execution.hexId + 'execution-mail-view'">
              <div v-if="automationRequestTabs === 2">
                <execution-email :execution="execution" />
              </div>
            </v-tab-item>
            <v-tab-item :key="execution.hexId + 'execution-task-view'">
              <div v-if="automationRequestTabs === 3">
                <execution-tasks :execution="execution" />
              </div>
            </v-tab-item>
            <v-tab-item :key="execution.hexId + 'execution-docs-view'">
              <div v-if="automationRequestTabs === 4">
                <execution-documents :execution="execution" />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
        <div v-else-if="execution.executionType === 'BOT'">
          <automation-request-bot-detail :execution-input="execution" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
